import { render, staticRenderFns } from "./KmartButton.vue?vue&type=template&id=3490ed20&"
import script from "./KmartButton.vue?vue&type=script&lang=js&"
export * from "./KmartButton.vue?vue&type=script&lang=js&"
import style0 from "./KmartButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports